import React, { useState } from 'react';
import ComentariosDrawer from './ComentariosDrawer';

/**
 * Componente simple que solo maneja el estado del drawer
 * El botón visual se renderiza en NoticiaAutorYCompartir
 */
const ComentariosSection = ({ slug, commentsCount: initialCount, children }) => {
    const [drawerOpen, setDrawerOpen] = useState(false);
    const [localCommentsCount, setLocalCommentsCount] = useState(initialCount || 0);

    const handleOpenDrawer = () => {
        setDrawerOpen(true);
    };

    const handleCloseDrawer = () => {
        setDrawerOpen(false);
    };

    const handleCommentAdded = () => {
        setLocalCommentsCount((prev) => prev + 1);
    };

    const handleCommentDeleted = () => {
        setLocalCommentsCount((prev) => Math.max(0, prev - 1));
    };

    return (
        <>
            {/* Renderizar el children que será el botón desde el componente padre */}
            {children && typeof children === 'function'
                ? children(handleOpenDrawer, localCommentsCount)
                : null}

            <ComentariosDrawer
                open={drawerOpen}
                onClose={handleCloseDrawer}
                slug={slug}
                onCommentAdded={handleCommentAdded}
                onCommentDeleted={handleCommentDeleted}
            />
        </>
    );
};

export default ComentariosSection;
